import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

// Colors matching the image
const COLORS = [
  '#436cda', // Purple
  '#ffd700', // Gold
  '#98FB98', // Light green
  '#FF69B4', // Pink
  '#00b9eb', // Medium slate blue
  '#FF8042',  // Orange
  // Another color not black
  '#808080' // Gray
];

// Bottom legend data display component
const BottomLegend = ({ data }) => {
  return (
    <div className="grid grid-cols-3 gap-1 mt-4 text-center">
      {data.map((item, index) => (
        <div key={index} className={`flex flex-col ${(index + 1) % 3 < 1 ? '' : 'border-r-2'} border-gray-200 justify-center items-center`}>
          <div className="flex flex-row justify-center items-center gap-1">
            <div className={`w-2 h-2 rounded-full`}
              style={{ backgroundColor: COLORS[index] }}
            ></div>
            <span className="text-sm font-bold">
              {(item?.value || 0).toFixed(1)}%
            </span>
          </div>
          <span className="text-sm text-gray-600">{item?.name || 'N/A'}</span>
        </div>
      ))}
    </div>
  );
};

const CustomDonutChart = ({ questionData }) => {
  const [answers, setAnswers] = useState([]);

  useEffect(() => {
    const defaultData = [
      { name: "White American", value: 0 },
      { name: "Hispanic", value: 0 },
      { name: "Veterans", value: 0 },
      { name: "Asian American", value: 0 },
      { name: "Women", value: 0 },
      { name: "Black American", value: 0 }
    ];

    setAnswers(
      questionData?.order === '2'
        ? questionData?.answer?.map((answer) => ({
          name: answer?.value || 'N/A',
          value: answer?.option_average || 0
        })) || defaultData
        : defaultData
    );
  }, [questionData]);

  const total = answers.reduce((acc, item) => acc + (item.value || 0), 0);

  // Create modified data with minimum values when total is 0
  const chartData = total === 0
    ? answers.map(item => ({ ...item, value: 1 }))  // Set each segment to 1 for equal distribution
    : answers;

  return (
    <div className="w-full">
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}  // Use the modified data
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              fill="#8884d8"
              paddingAngle={2}
              dataKey="value"
              startAngle={90}
              endAngle={450}
            >
              {answers.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={total === 0 ? '#d3d3d3' : COLORS[index % COLORS.length]}
                  strokeWidth={0}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      <BottomLegend data={answers} />
    </div>
  );
};

export default CustomDonutChart;